import { Navigate } from "react-router-dom";

export default function CreateAgentTab() {
  return <Navigate to="/forex/agents/create" replace />;
}
